"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../../v2/PhoneNumberForm/LineNumber/index.scss");
const react_hook_form_1 = require("react-hook-form");
const FieldErrorSectionForm_1 = __importDefault(require("@App/kit/fields/FieldErrorSectionForm"));
const clsx_1 = __importDefault(require("clsx"));
const LineNumber = (props) => {
    const formState = (0, react_hook_form_1.useFormState)();
    const { register } = (0, react_hook_form_1.useFormContext)();
    const { name, registerOptions, assistiveTextFunction } = props;
    const error = (0, react_hook_form_1.get)(formState.errors, name);
    const innerClassNames = (0, clsx_1.default)('input-text-form-component', 'main-color-set', error && 'error');
    const required = !!registerOptions && !!registerOptions.required;
    const assistiveText = assistiveTextFunction ? assistiveTextFunction(required) : '';
    return (react_1.default.createElement("div", { className: "input-line-number", "data-testid": name },
        react_1.default.createElement("div", { className: innerClassNames },
            react_1.default.createElement("label", { htmlFor: name }),
            react_1.default.createElement("input", Object.assign({}, register(name, registerOptions))),
            react_1.default.createElement(FieldErrorSectionForm_1.default, { name: name, assistiveText: assistiveText, required: required }))));
};
exports.default = LineNumber;
